import React from "react";
import styles from "../styles/DrpAboutPage.css";
import Header from "../components/Header";

import Footer from "../components/Footer";

import Navbar from "../components/Navbar";
const DrpAboutPage = () => {
  return (
    <>
      <Header />
      <Navbar />

      <Footer />
    </>
  );
};

export default DrpAboutPage;
